// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs___3ui5Z","breadcrumbs-tab":"breadcrumbs-tab___3dfWc","separator":"separator___3oAaN","now-active":"now-active___2I7pB"};